import React from 'react'
import { Cell } from 'react-mdl'
import { HorizontalBar } from 'react-chartjs-2';
import './style.css'

export default class Skills extends React.Component {

    state = {
        activeWeaponTabId: 0,
        expansion: false,
        datasets: []
    }

    constructor(props) {
        super(props);

        var labels = [];
        var points = [];
        var main_hand_bonus_points = [];
        var secondary_hand_bonus_points = [];

        props.data.skills.map(function (skill) {
            labels.push(skill.name);
            points.push(skill.points);
            main_hand_bonus_points.push(skill.main_hand_bonus_points);
            secondary_hand_bonus_points.push(skill.secondary_hand_bonus_points);
            return true;
        });

        var hardSkillsBackgroundColors = [];
        let i = 0;
        while (i < 30) {
            hardSkillsBackgroundColors.push('rgba(87, 147, 150, 0.7)');
            i++;
        }

        var bonusSkillsBackgroundColors = [];
        i = 0;
        while (i < 30) {
            bonusSkillsBackgroundColors.push('rgba(193, 66, 66, 0.5)');
            i++;
        }

        var mainHandDataset = {
            labels: labels,
            datasets: [
                {
                    label: "Hard Skills",
                    labelColor: "#ff0000",
                    backgroundColor: hardSkillsBackgroundColors,
                    borderWidth: 0,
                    data: points,
                },
                {
                    label: "Bonus from items",
                    labelColor: "#ff0000",
                    backgroundColor: bonusSkillsBackgroundColors,
                    borderWidth: 0,
                    data: main_hand_bonus_points,
                }
            ]
        }
        var secondaryHandDataset = {
            labels: labels,
            datasets: [
                {
                    label: "Hard Skills",
                    labelColor: "#ff0000",
                    backgroundColor: hardSkillsBackgroundColors,
                    borderWidth: 0,
                    data: points,
                },
                {
                    label: "Bonus from items",
                    labelColor: "#ff0000",
                    backgroundColor: bonusSkillsBackgroundColors,
                    borderWidth: 0,
                    data: secondary_hand_bonus_points,
                }
            ]
        }

        this.state = {
            activeWeaponTabId: 0,
            expansion: props.data.expansion,
            datasets: [mainHandDataset, secondaryHandDataset]
        };
    }

    handleSwitchWeapons(activeWeaponTabId) {
        this.setState({ activeWeaponTabId: activeWeaponTabId });
    }

    render() {
        return (
            <Cell className="skills" col={8} tablet={12} phone={12}>
                <h3 className="underlined">Skills</h3>
                <div className="skill-chart">
                    <HorizontalBar
                        data={this.state.datasets[this.state.activeWeaponTabId]}
                        redraw={this.state.expansion}
                        height={430}
                        options={{
                            tooltips: {
                                mode: 'label',
                                displayColors: false,
                                callbacks: {
                                    label: function(tooltipItem, data) {
                                        var label = data.datasets[tooltipItem.datasetIndex].label;
                                        var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                                        // Loop through all datasets to get the actual total of the index
                                        var total = 0;
                                        for (var i = 0; i < data.datasets.length; i++) {
                                            total += data.datasets[i].data[tooltipItem.index]
                                        }

                                        // If it is not the last dataset, display it as you usual
                                        if (tooltipItem.datasetIndex !== data.datasets.length - 1) {
                                            return label + " : " + value;
                                        } else { // .. else, display the dataset and the total, using an array
                                            return [label + " : " + value, "Total : " + total];
                                        }
                                    }
                                }
                            },
                            maintainAspectRatio: false,
                            barThickness: 10,
                            scales: {
                                yAxes: [{
                                    ticks: {
                                        fontfamily: "'Roboto'",
                                        fontColor: "#a99877",
                                        fontSize: 11,
                                    },
                                    stacked: true
                                }],
                                xAxes: [{
                                    ticks: {
                                        fontColor: "#a99877",
                                        fontSize: 11,
                                    },
                                    stacked: true
                                }]
                            },
                            legend: { display: false }
                        }}
                    />
                </div>
            </Cell>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/character/skills/index.js